import { badgeSonar } from '../../assets/index.js'

interface SonarBadgeProps {
  /** Pixel position of the center cell */
  x: number
  y: number
  count: number
}

/**
 * Persistent sonar count badge shown on the center cell after a sonar ping.
 * ART_GUIDE_v2 §2.4: Badge is permanent for the rest of the game.
 * Renders above all markers and is exempt from disabled-cell desaturation.
 */
export function SonarBadge({ x, y, count }: SonarBadgeProps) {
  return (
    <div style={{
      position: 'absolute',
      left: x + 38,  // top-right corner of cell, 2px inset
      top: y + 2,
      width: 24,
      height: 24,
      pointerEvents: 'none',
      zIndex: 20,
    }}>
      <img
        src={badgeSonar}
        alt=""
        draggable={false}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
        }}
      />
      <span style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 700,
        color: '#EAF2F8',
      }}>
        {count}
      </span>
    </div>
  )
}
